// AUTHENTICATION ACTIONS

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

// PROFILE ACTIONS

export const FETCH_PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';

// CLIENT ACTIONS

export const ADD_CLIENT_REQUEST = 'ADD_CLIENT_REQUEST';
export const ADD_CLIENT_SUCCESS = 'ADD_CLIENT_SUCCESS';
export const ADD_CLIENT_FAILURE = 'ADD_CLIENT_FAILURE';

export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';
export const UPDATE_CLIENT_FAILURE = 'UPDATE_CLIENT_FAILURE';

export const DEACTIVATE_CLIENT_REQUEST = 'DEACTIVATE_CLIENT_REQUEST';
export const DEACTIVATE_CLIENT_SUCCESS = 'DEACTIVATE_CLIENT_SUCCESS';
export const DEACTIVATE_CLIENT_FAILURE = 'DEACTIVATE_CLIENT_FAILURE';

export const FETCH_CLIENTS_REQUEST = 'FETCH_CLIENTS_REQUEST';
export const FETCH_CLIENTS_SUCCESS = 'FETCH_CLIENTS_SUCCESS';
export const FETCH_CLIENTS_FAILURE = 'FETCH_CLIENTS_FAILURE';

export const UPDATE_CLIENTS_FILTER = 'UPDATE_CLIENTS_FILTER';
export const RESET_CLIENTS_FILTER = 'RESET_CLIENTS_FILTER';

export const UPDATE_CLIENTS_SORTING = 'UPDATE_CLIENTS_SORTING';
export const RESET_CLIENTS_SORTING = 'RESET_CLIENTS_SORTING';

// USER ACTIONS

export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = 'ADD_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const DEACTIVATE_USER_REQUEST = 'DEACTIVATE_USER_REQUEST';
export const DEACTIVATE_USER_SUCCESS = 'DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_FAILURE = 'DEACTIVATE_USER_FAILURE';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const UPDATE_USERS_FILTER = 'UPDATE_USERS_FILTER';
export const RESET_USERS_FILTER = 'RESET_USERS_FILTER';

export const UPDATE_USERS_SORTING = 'UPDATE_USERS_SORTING';
export const RESET_USERS_SORTING = 'RESET_USERS_SORTING';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

// TERMINAL ACTIONS

export const ADD_TERMINAL_REQUEST = 'ADD_TERMINAL_REQUEST';
export const ADD_TERMINAL_SUCCESS = 'ADD_TERMINAL_SUCCESS';
export const ADD_TERMINAL_FAILURE = 'ADD_TERMINAL_FAILURE';

export const UPDATE_TERMINAL_REQUEST = 'UPDATE_TERMINAL_REQUEST';
export const UPDATE_TERMINAL_SUCCESS = 'UPDATE_TERMINAL_SUCCESS';
export const UPDATE_TERMINAL_FAILURE = 'UPDATE_TERMINAL_FAILURE';

export const DECOMMISSION_TERMINAL_REQUEST = 'DECOMMISSION_TERMINAL_REQUEST';
export const DECOMMISSION_TERMINAL_SUCCESS = 'DECOMMISSION_TERMINAL_SUCCESS';
export const DECOMMISSION_TERMINAL_FAILURE = 'DECOMMISSION_TERMINAL_FAILURE';

export const DEACTIVATE_TERMINAL_REQUEST = 'DEACTIVATE_TERMINAL_REQUEST';
export const DEACTIVATE_TERMINAL_SUCCESS = 'DEACTIVATE_TERMINAL_SUCCESS';
export const DEACTIVATE_TERMINAL_FAILURE = 'DEACTIVATE_TERMINAL_FAILURE';

export const ACTIVATE_TERMINAL_REQUEST = 'ACTIVATE_TERMINAL_REQUEST';
export const ACTIVATE_TERMINAL_SUCCESS = 'ACTIVATE_TERMINAL_SUCCESS';
export const ACTIVATE_TERMINAL_FAILURE = 'ACTIVATE_TERMINAL_FAILURE';

export const FETCH_TERMINALS_REQUEST = 'FETCH_TERMINALS_REQUEST';
export const FETCH_TERMINALS_SUCCESS = 'FETCH_TERMINALS_SUCCESS';
export const FETCH_TERMINALS_FAILURE = 'FETCH_TERMINALS_FAILURE';

export const UPDATE_TERMINALS_FILTER = 'UPDATE_TERMINALS_FILTER';
export const RESET_TERMINALS_FILTER = 'RESET_TERMINALS_FILTER';

export const UPDATE_TERMINALS_SORTING = 'UPDATE_TERMINALS_SORTING';
export const RESET_TERMINALS_SORTING = 'RESET_TERMINALS_SORTING';

// CREDIT CARD ACTIONS

export const ADD_CARD_REQUEST = 'ADD_CARD_REQUEST';
export const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS';
export const ADD_CARD_FAILURE = 'ADD_CARD_FAILURE';

export const UPDATE_CARD_REQUEST = 'UPDATE_CARD_REQUEST';
export const UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS';
export const UPDATE_CARD_FAILURE = 'UPDATE_CARD_FAILURE';

export const DECOMMISSION_CARD_REQUEST = 'DECOMMISSION_CARD_REQUEST';
export const DECOMMISSION_CARD_SUCCESS = 'DECOMMISSION_CARD_SUCCESS';
export const DECOMMISSION_CARD_FAILURE = 'DECOMMISSION_CARD_FAILURE';

export const DELETE_CARD_REQUEST = 'DELETE_CARD_REQUEST';
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS';
export const DELETE_CARD_FAILURE = 'DELETE_CARD_FAILURE';

export const DEACTIVATE_CARD_REQUEST = 'DEACTIVATE_CARD_REQUEST';
export const DEACTIVATE_CARD_SUCCESS = 'DEACTIVATE_CARD_SUCCESS';
export const DEACTIVATE_CARD_FAILURE = 'DEACTIVATE_CARD_FAILURE';

export const ACTIVATE_CARD_REQUEST = 'ACTIVATE_CARD_REQUEST';
export const ACTIVATE_CARD_SUCCESS = 'ACTIVATE_CARD_SUCCESS';
export const ACTIVATE_CARD_FAILURE = 'ACTIVATE_CARD_FAILURE';

export const FETCH_CARDS_REQUEST = 'FETCH_CARDS_REQUEST';
export const FETCH_CARDS_SUCCESS = 'FETCH_CARDS_SUCCESS';
export const FETCH_CARDS_FAILURE = 'FETCH_CARDS_FAILURE';

export const UPDATE_CARDS_FILTER = 'UPDATE_CARDS_FILTER';
export const RESET_CARDS_FILTER = 'RESET_CARDS_FILTER';

export const UPDATE_CARDS_SORTING = 'UPDATE_CARDS_SORTING';
export const RESET_CARDS_SORTING = 'RESET_CARDS_SORTING';

// CREDIT ACH ACTIONS

export const ADD_ACH_REQUEST = 'ADD_ACH_REQUEST';
export const ADD_ACH_SUCCESS = 'ADD_ACH_SUCCESS';
export const ADD_ACH_FAILURE = 'ADD_ACH_FAILURE';

export const UPDATE_ACH_REQUEST = 'UPDATE_ACH_REQUEST';
export const UPDATE_ACH_SUCCESS = 'UPDATE_ACH_SUCCESS';
export const UPDATE_ACH_FAILURE = 'UPDATE_ACH_FAILURE';

export const DECOMMISSION_ACH_REQUEST = 'DECOMMISSION_ACH_REQUEST';
export const DECOMMISSION_ACH_SUCCESS = 'DECOMMISSION_ACH_SUCCESS';
export const DECOMMISSION_ACH_FAILURE = 'DECOMMISSION_ACH_FAILURE';

export const DEACTIVATE_ACH_REQUEST = 'DEACTIVATE_ACH_REQUEST';
export const DEACTIVATE_ACH_SUCCESS = 'DEACTIVATE_ACH_SUCCESS';
export const DEACTIVATE_ACH_FAILURE = 'DEACTIVATE_ACH_FAILURE';

export const ACTIVATE_ACH_REQUEST = 'ACTIVATE_ACH_REQUEST';
export const ACTIVATE_ACH_SUCCESS = 'ACTIVATE_ACH_SUCCESS';
export const ACTIVATE_ACH_FAILURE = 'ACTIVATE_ACH_FAILURE';

export const FETCH_ACHS_REQUEST = 'FETCH_ACHS_REQUEST';
export const FETCH_ACHS_SUCCESS = 'FETCH_ACHS_SUCCESS';
export const FETCH_ACHS_FAILURE = 'FETCH_ACHS_FAILURE';

export const UPDATE_ACHS_FILTER = 'UPDATE_ACHS_FILTER';
export const RESET_ACHS_FILTER = 'RESET_ACHS_FILTER';

export const UPDATE_ACHS_SORTING = 'UPDATE_ACHS_SORTING';
export const RESET_ACHS_SORTING = 'RESET_ACHS_SORTING';

// TERMINAL HEALTH REPORT ACTIONS

export const FETCH_BPT_HEALTH_REPORT_REQUEST = 'FETCH_BPT_HEALTH_REPORT_REQUEST';
export const FETCH_BPT_HEALTH_REPORT_SUCCESS = 'FETCH_BPT_HEALTH_REPORT_SUCCESS';
export const FETCH_BPT_HEALTH_REPORT_FAILURE = 'FETCH_BPT_HEALTH_REPORT_FAILURE';

// PAYMENT ACTIONS

export const FETCH_PAYMENTS_REQUEST = 'FETCH_PAYMENTS_REQUEST';
export const FETCH_PAYMENTS_SUCCESS = 'FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_FAILURE = 'FETCH_PAYMENTS_FAILURE';

export const UPDATE_PAYMENTS_FILTER = 'UPDATE_PAYMENTS_FILTER';
export const RESET_PAYMENTS_FILTER = 'RESET_PAYMENTS_FILTER';

export const UPDATE_PAYMENTS_SORTING = 'UPDATE_PAYMENTS_SORTING';
export const RESET_PAYMENTS_SORTING = 'RESET_PAYMENTS_SORTING';

// MIDDLEWARE ACTIONS

export const API_CALL = 'API_CALL';
export const AUTHENTICATE = 'AUTHENTICATE';

// ERROR ACTIONS

export const UPDATE_ERROR = 'UPDATE_ERROR';
export const RESET_ERROR = 'RESET_ERROR';

// PAGINATION ACTIONS

export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_PAGE_SIZE = 'UPDATE_PAGE_SIZE';
